import React from "react";
import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

const IdentificationField = ({ identification, ciudad }) => {
  return (
    <SuiBox mb={2}>
      <SuiBox display="flex" alignItems="center" justifyContent="space-between">
        <SuiTypography variant="subtitle2" fontWeight="medium" textColor="text">
          Identificación - Ciudad
        </SuiTypography>
      </SuiBox>
      <SuiBox>
        <SuiTypography variant="button" fontWeight="regular" textColor="text">
          {identification || "No especificado"} - {ciudad || "No especificado"}
        </SuiTypography>
      </SuiBox>
    </SuiBox>
  );
};

IdentificationField.propTypes = {
  identification: PropTypes.string,
  ciudad: PropTypes.string,
};

export default IdentificationField;
